<template>
  <super-admin-layout>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat class="text-right">
            <v-card-actions>
              <v-btn
                color="secondary"
                outlined
                class="mr-1"
                to="/super-admin/courses"
              >
                <v-icon class="mr-1" small>fa-chevron-left</v-icon>Back to
                Course List
              </v-btn>
              <v-spacer></v-spacer>
              <AddCourseMaterial :id="id" />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6"> </v-col>
        <v-col md="6">
          <v-card flat>
            <v-toolbar color="secondary" flat>
              <v-toolbar-title class="white--text">
                <v-icon class="icon white--text">fa-list</v-icon>Training
                Material
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <div v-if="assets.length > 0">
              <v-subheader
                >Drag items to rearrange training material order</v-subheader
              >
              <SortCourseMaterial :assets="assets" :id="id" />
            </div>
            <div v-else>
              <p class="pa-5">No course materials added.</p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import SuperAdminLayout from '@/layouts/SuperAdmin';
import AddCourseMaterial from '@/components/partner/course/AddCourseMaterial';
import SortCourseMaterial from '@/components/partner/course/SortCourseMaterial';
import CourseStats from '@/components/partner/course/CourseStats';
import Publish from '@/components/partner/course/Publish';

import EnrolUsers from '@/components/partner/course/Enrol';
import ManageDeadlines from '@/components/partner/course/ManageDeadlines';
import RemoveUsers from '@/components/partner/course/RemoveUsers';
import EditCourse from '@/components/partner/course/Edit';

import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import thumbSizes from '@/utils/thumbs.js';

export default {
  components: {
    SuperAdminLayout,
    AddCourseMaterial,
    SortCourseMaterial,
    CourseStats,
    Publish,
  },
  data() {
    return {
      id: this.$route.params.id,
      courseMaterials: [],
      manage: true,
      file: false,
      canPublish: false,
      totalVideos: 0,
      noMaterialsMessage: 'Please add some course Materials',
    };
  },
  computed: {
    assets() {
      return this.$store.getters.courseMaterials;
    },
    course() {
      return this.$store.getters.course;
    },
    published() {
      return this.$store.getters.course.published == 0 ? false : true;
    },
    topics() {
      return this.$store.getters.course.data.topics;
    },
  },
  created() {
    this.$store.dispatch('setCourse', {});
    this.$store.dispatch('setCourseMaterials', {});
  },
  mounted() {
    this.getCourse();
    this.setEventBus();
  },
  methods: {
    getCourse() {
      courseAPI
        .getCourse(this.id, '?include=thumbnail,assets')
        .then((response) => {
          this.$store.dispatch('setCourse', response.data.data);
          this.$store.dispatch(
            'setCourseMaterials',
            response.data.data.assets.data
          );
          //this.updateThumb();
        });
    },
    deleteCourse() {
      courseAPI.deleteCourse(this.id).then((response) => {
        this.$router.push({ path: '/admin/courses' });
      });
    },
    setEventBus() {
      //EventBus.$on("ASSET_ADDED", payload => {
      //  this.courseMaterials.push(payload.data.data);
      //  this.sortList(false);
      //});
      EventBus.$on('COURSE_UPDATED', (payload) => {
        this.course = payload;
        this.updateThumb();
        this.getCourse();
      });
    },
    showEnrolPanel() {
      this.$showPanel({
        component: EnrolUsers,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showEditPanel() {
      this.$showPanel({
        component: EditCourse,
        props: {
          id: this.id,
          params: this.params,
          courseManager: true,
        },
        openOn: 'right',
      });
    },
    showManageUsersPanel() {
      this.$showPanel({
        component: ManageUsers,
        props: {
          id: this.id,
          manage: this.manage,
        },
        openOn: 'right',
      });
    },
    showManageDeadlinesPanel() {
      this.$showPanel({
        component: ManageDeadlines,
        disableBgClick: true,
        props: {
          id: this.id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showRemoveUsersPanel() {
      this.$showPanel({
        component: RemoveUsers,
        disableBgClick: true,
        props: {
          id: this.id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
  },
};
</script>
